module.exports = __webpack_public_path__ + "static/media/22.60166d40.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/pants/22.png
// module id = 875
// module chunks = 0